import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import {
    Button,
    Tooltip
} from '@mui/material'
import DocumentsButton from "@/components/ui/DocumentsButton";
import {
    handleDocumentsForRelatedTableRecordByPublicAccessFetch,
    handleDocumentsForRelatedTableRecordFetch,
} from "@/pages/Documents/store/Documents";
import { DocumentTypeEnum } from '@/lib/utils/DocumentTypeEnum';
import { PrembidLocalStorage } from "@/lib/utils/PrembidLocalStorage";
import { downloadFile } from "@/pages/Documents/store/Documents";
import { sortBy } from 'lodash';
import useStyles from './styles/AuctionDetailCardDocumentSelectorStyles';
import { DocumentPopper } from '../composite/popper/DocumentPopper';

interface Props {
    auctionId: string,
    profileId?: string,
    documents: any,
    relatedId: any,
    documentCount?: number,

    handleDocumentsForRelatedTableRecordByPublicAccessFetch_d: (relatedTableRecordId: string, currentDocumentType: any) => void,
    handleDocumentsForRelatedTableRecordFetch_d: (relatedTableRecordId: string, currentDocumentType: any) => void,
    downloadFile_d: (url: string, onCompletedCallback?: (res: any) => void) => void,
    type?: 'badge' | 'button'
}

const AuctionDetailCardDocumentSelector: React.FC<Props> = props => {
    const { classes } = useStyles();
    const {
        auctionId,
        profileId,
        documents,
        relatedId,

        handleDocumentsForRelatedTableRecordByPublicAccessFetch_d,
        handleDocumentsForRelatedTableRecordFetch_d,
        documentCount,
        downloadFile_d,
        type = 'badge'
    } = props;

    const [anchorEl, setAnchorEl] = React.useState(null);
    const [auctionDocuments, setAuctionDocuments] = React.useState<any>([] as any);
    const [isBusy, setIsBusy] = React.useState(false);
    const [isDocumentOpen, setIsDocumentOpen] = React.useState(false);

    const handleDocumentClick = (event) => {
        if (!isDocumentOpen) {
            setIsDocumentOpen(true);
            setAnchorEl(event.currentTarget);
            setIsBusy(true);
            if (profileId) {
                handleDocumentsForRelatedTableRecordFetch_d(auctionId, DocumentTypeEnum.Auction);
            } else {
                handleDocumentsForRelatedTableRecordByPublicAccessFetch_d(auctionId, DocumentTypeEnum.Auction);
            }
        }
    };

    const handleDocumentClose = () => {
        if (!isBusy) {
            setIsDocumentOpen(false);
            setAnchorEl(null);
        }
    };

    React.useEffect(() => {
        if (documents !== undefined
            && relatedId == auctionId) {
            const newDocumentsData: any = [];

            Object.entries<any>(documents).forEach(([key, value]) => {
                Object.entries<any>(value).forEach(([docTemplateResultKey, docTemplateResultValue]) => {
                    if (docTemplateResultValue.documentTemplate.dataCaptured.auction.isApplied && !docTemplateResultValue.documentTemplate.dataCaptured.auction.isUploadMandatory) {
                        if (docTemplateResultValue.documents.length > 0) {
                            Object.entries<any>(docTemplateResultValue.documents).forEach(([docResultKey, docResultValue]) => {
                                const newFields: any = {
                                    documentUrl: docResultValue.documentUrl,
                                    documentTemplateName: docTemplateResultValue.documentTemplate.name,
                                };

                                if (newFields.documentUrl !== undefined && newFields.documentUrl !== null) {
                                    newDocumentsData.push(newFields);
                                }
                            });
                        }
                    }
                });
            });
            const sortedDocuments = sortBy(newDocumentsData, ['documentTemplateName', 'documentUrl']);
            setAuctionDocuments(sortedDocuments);
            setIsBusy(false);
        }
    }, [documents, relatedId]);

    const handleViewDocument = (url: string, onCompletedCallback?: () => void) => {
        downloadFile_d(url, (response: any) => {
            if (response) {
                response.blob().then(blob => {
                    const fileURL = URL.createObjectURL(blob);
                    window.open(fileURL, '_blank', 'noreferrer');
                });
            }
            onCompletedCallback?.();
        })
    }

    const renderAsBadge = () => <>
        <DocumentsButton count={documentCount} onClick={handleDocumentClick} />
        {anchorEl && <DocumentPopper {...{ anchorEl, isBusy, documents: auctionDocuments, handleDocumentClose, handleViewDocument }} />}
    </>

    const renderAsButton = () => <>
        <Tooltip arrow title="View Documents" placement="bottom" PopperProps={{ style: { zIndex: 24 } }}>
            <Button aria-controls="simple-menu" aria-haspopup="true" size="large" onClick={handleDocumentClick} variant="contained" fullWidth className={classes.buttonContainer + " btn-primary p-3 text-white mr-1"} style={{ textTransform: 'none' }}>
                Auction Documents
            </Button>
        </Tooltip>
        {anchorEl && <DocumentPopper {...{ anchorEl, isBusy, documents: auctionDocuments, popperStyle: { zIndex: 24 }, handleDocumentClose, handleViewDocument }} />}
    </>

    return type === 'button' ? renderAsButton() : renderAsBadge();
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        handleDocumentsForRelatedTableRecordByPublicAccessFetch_d: (relatedTableRecordId: string, currentDocumentType: any) => dispatch(handleDocumentsForRelatedTableRecordByPublicAccessFetch(relatedTableRecordId, currentDocumentType)),
        handleDocumentsForRelatedTableRecordFetch_d: (relatedTableRecordId: string, currentDocumentType: any) => dispatch(handleDocumentsForRelatedTableRecordFetch(relatedTableRecordId, currentDocumentType)),
        downloadFile_d: (url: any, onCompletedCallback?: (res: any) => void) => dispatch(downloadFile(url, onCompletedCallback)),
    }
}

const mapStateToProps = (state: any) => ({
    documents: state.documents.documents,
    profileId: state.loginForm.changeProfileId,
    relatedId: state.documents.relatedId
});

export default connect(mapStateToProps, mapDispatchToProps)(AuctionDetailCardDocumentSelector);
